import axios from "axios";

import {
  reducerExcelUnloadingsFilters,
  reducerExcelUnloadings,
  reducerExcelSingleUnloadings,
  reducerExcelUploadingStatus
} from "../../reducer/unloadings/reducers/excelUnloadings";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetExcelUnloadings =
  (limit: number, page: number) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const store = getState();
    const filter = store.unloadings.excelUnloadings.excelUnloadingsInputValues;
    try {
      const response = await axios.post(`${BASE_URL}/json/orders/excel`, {
        limit,
        page,
        ...filter,
      });
  
      dispatch(reducerExcelUnloadings({ data: response.data, limit, page: 1 }));
    } catch (e: any) {
      if (e.response.status === 401) {
        window.location.href = "/login";
      }
    }

  };

export const actionGetExcelUnloadingsFilters =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(`${BASE_URL}/json/orders/excel/filters`);

      dispatch(reducerExcelUnloadingsFilters({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

  
export const actionGetExcelUnloadingsRetry =
(id: {id: number}) =>
async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.post(`${BASE_URL}/json/orders/excel/retry`, id);
    dispatch(reducerExcelSingleUnloadings(response.data));  
  } catch {
    console.log('err');
  };
};

export const actionDeleteExcelUnloadings =
(id: number) =>
async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.delete(`${BASE_URL}/json/orders/delete/excel/${id}`);
    return response;
  } catch {
    dispatch(reducerExcelUploadingStatus(0));
  }
};